import { Params } from '@angular/router';

import { filter } from 'rxjs/operators';
import { map } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { ApacDetailService } from '../apac-detail.service'

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  constructor(private service: ApacDetailService) { }

  disabledBut: boolean = true;
  sendMessage: string = 'Refresh Report List';
  volumesList: any[] = [];
  loading: boolean = false;
  lastUpdateDate: any;

  ngOnInit() {
    let params = {
      action: 'query'
    };
    this.service.refreshAction(params).subscribe(res => {
      const { apac_status, japan_status } = res['data'];
      if (apac_status != 1 && japan_status != 1) {
        this.disabledBut = false;
        this.sendMessage = 'Refresh Report List';
      } else {
        this.sendMessage = 'Refreshing';
        this.pollingReport();
      }
    });
    this.getListData();
  }

  async getListData() {
    this.loading = true;
    try {
      const apacList = await this.service.getVolumesList().toPromise();
      if (apacList['items'][0] && apacList['items'][0].last_update_time) {
        this.lastUpdateDate = apacList['items'][0].last_update_time;
      }
      const japanList = await this.getCountryList('Japan', 'total');
      const chinaList = await this.getCountryList('China', 'total');
      const koreaList = await this.getCountryList('Korea', 'total');
      const mapList = (items) => {
        let listData = items['items'].map(value => {
          const len = value.date_month_key.length;
          value.date_month_key = value.date_month_key.substring(len - 6, len);
          return value;
        });
        return listData;
      }
      let japan = mapList(japanList);
      let china = mapList(chinaList);
      let korea = mapList(koreaList);
      japan = japan.splice(japan.length - 12, japan.length);
      china = china.splice(china.length - 12, china.length);
      korea = korea.splice(korea.length - 12, korea.length);
      this.volumesList = mapList(apacList).concat(japan).concat(china).concat(korea);
      this.volumesList.sort((data, last) => {
        return last.date_month_key - data.date_month_key;
      });
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw (e);
    }
  }

  async getCountryList(country, type) {
    try {
      const list = await this.service.getVolumesDetail({
        month: country, type: type
      }).toPromise();
      return list;
    } catch (e) {
      return e;
    }
  }

  refreshList(type) {
    let params = {
      action: type
    }
    this.disabledBut = true;
    this.sendMessage = 'Refreshing';
    this.service.refreshAction(params).subscribe(res => {
      this.pollingReport();
    }, err => {
      this.disabledBut = false;
      this.sendMessage = `Refresh Failed`;
    });
  }

  pollingReport() {
    let params = {
      action: 'query'
    };
    const interval = setInterval(() => {
      this.service.refreshAction(params).subscribe(res => {
        if (!res) {
          statusConfirm();
          return;
        }
        const { apac_status, japan_status } = res['data'];
        if (apac_status != 1 && japan_status != 1) {
          if (apac_status == 2 && japan_status == 2) {
            statusConfirm(true);
          } else {
            statusConfirm();
          }
        }
      }, err => {
        statusConfirm();
      });
    }, 3000);

    const statusConfirm = (success?) => {
      this.getListData();
      this.disabledBut = false;
      clearInterval(interval);
      if (success) {
        this.sendMessage = 'Refresh Successed';
      } else {
        this.sendMessage = 'Refresh Failed'
      }
    }
  }

  stringifyData(data){
    return JSON.stringify(data)
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/apac-detail/list/list.component.ts